import React, { useEffect } from "react";
import { LedgerStatementType } from "../../../../redux/reports/reportsType";
import {
  currencySignAndNegativeValueAdjust,
  formatDate,
} from "../../../../utils/commonFunctions";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Iicon, tableEditIcon } from "../../../../assets/images";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";
import { FONT_COL_CODES, STAGE_COLOR_CODES } from "../../../../constant/colors";

type AppProps = {
  ledgerStatementData: [] | LedgerStatementType[];
  client_code: number;
  company_name: string;
  currencySign: string;
  handleManageRedirectToInvoice: (invoiceType: number) => void;
  handleCustomerSuplierDetailsData: (data: number) => void;
};

const LedgerStatementTableData = ({
  ledgerStatementData,
  handleManageRedirectToInvoice,
  client_code,
  company_name,
  currencySign,
  handleCustomerSuplierDetailsData,
}: AppProps) => {
  const [isEditOthersPresent, setIsEditOthersPresent] = useMenuCheck();
  const [isEditSalesPresent, setIsEditSalesPresent] = useMenuCheck();
  const [isEditExpensePresent, setIsEditExpensePresent] = useMenuCheck();

  useEffect(() => {
    setIsEditOthersPresent("Edit Others Invoicing Advanced", "menu");
    setIsEditSalesPresent("Edit Sales Invoicing Advanced", "menu");
    setIsEditExpensePresent("Edit Expense Invoicing Advanced", "menu");
  }, []);

  const backColor = (type: number) => {
    let backgroundColor;
    let fontColor;

    if (type === 1) {
      backgroundColor = STAGE_COLOR_CODES[1];
      fontColor = FONT_COL_CODES[1];
    } else if (type === 2) {
      backgroundColor = STAGE_COLOR_CODES[4];
      fontColor = FONT_COL_CODES[4];
    } else if (type === 3) {
      backgroundColor = STAGE_COLOR_CODES[5];
      fontColor = FONT_COL_CODES[5];
    } else {
      backgroundColor = STAGE_COLOR_CODES[1];
      fontColor = FONT_COL_CODES[1];
    }

    return {
      backgroundColor,
      fontColor,
    };
  };

  const styleColor = (type: number) => {
    const { backgroundColor, fontColor } = backColor(type);

    return {
      marginTop: "20px",
      padding: "4px 12px",
      color: fontColor,
      background: backgroundColor,
      borderRadius: "16px",
    };
  };

  const blank = () => {
    return {};
  };

  const renderEditIcon = (finalLink: string) => {
    return (
      <td>
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 250 }}
          overlay={renderViewInvoiceToolTip}
        >
          <Link
            onClick={handleSetLocalStorageData}
            target="_blank"
            to={finalLink}
          >
            <span
              style={{
                fontSize: "20px",
                padding: "8px",
                margin: "0px 0 0 3px",
                verticalAlign: "middle",
                cursor: "pointer",
              }}
            >
              <img src={tableEditIcon} alt="edit" />
            </span>
          </Link>
        </OverlayTrigger>
      </td>
    );
  };

  const renderViewInvoiceToolTip = (props: any) => {
    return (
      <Tooltip id={`button-send-email`} {...props}>
        View Invoice
      </Tooltip>
    );
  };


  const handleSetLocalStorageData = () => {
    const isRedirect: any = {
      isRedirected: "Yes",
    };
  };

  const renderLedgerStatementData = () => {
    let finalData =
      ledgerStatementData &&
      ledgerStatementData?.length > 0 &&
      ledgerStatementData?.map((ledgerData: LedgerStatementType) => {
        let finalLink =
          ledgerData?.invoice_type === 1 || ledgerData?.invoice_type === 2
            ? `/invoice-generation/edit/${
                ledgerData?.invoice_id
              }/${client_code}?type=${
                ledgerData?.invoice_type === 1 ? "expenses" : "revenues"
              }&client_code=${client_code}&company_name=${company_name}`
            : `/invoice-generation/edit-others/${client_code}/${ledgerData?.invoice_id}?type=others&client_code=${client_code}&company_name=${company_name}`;

        return (
          <tr className="text-center" key={ledgerData?.involved_ledger_id}>
            <td style={{ width: "120px" }}>
              {formatDate(ledgerData?.date_of_invoice)}
              {handleManageRedirectToInvoice(ledgerData?.invoice_type)}
            </td>
            {ledgerData?.involved_ledger_type_id === 2 ? (
              <td>
                {`${ledgerData?.involved_ledger_name}`}
                {
                  <img
                    className="ml-2 pointer"
                    alt="eye"
                    src={Iicon}
                    onClick={() =>
                      handleCustomerSuplierDetailsData?.(
                        ledgerData?.involved_ledger_id
                      )
                    }
                  />
                }
              </td>
            ) : (
              <td>{ledgerData?.involved_ledger_name}</td>
            )}
            <td style={{ maxWidth: "150px", wordWrap: "break-word" }}>
              {ledgerData?.narration?.length ? ledgerData?.narration : "--/--"}
            </td>
            <td>
              {ledgerData?.invoice_type == 3
                ? `100000${ledgerData.invoice_id}`
                : ledgerData?.document_no}
            </td>

            <td className="text-success">
              {currencySignAndNegativeValueAdjust(
                currencySign,
                ledgerData?.debit_amount
                  ? ledgerData?.debit_amount?.toFixed(2)?.toString()
                  : "0"
              )}
            </td>
            <td className="text-danger">
              {currencySignAndNegativeValueAdjust(
                currencySign,
                ledgerData?.credit_amount
                  ? ledgerData?.credit_amount?.toFixed(2)?.toString()
                  : "0"
              )}
            </td>
            <td>
              {currencySignAndNegativeValueAdjust(
                currencySign,
                ledgerData?.balance
                  ? ledgerData?.balance?.toFixed(2)?.toString()
                  : "0"
              )}
            </td>
            <td
              style={{
                width:
                  ledgerData?.category === "Compound" &&
                  ledgerData?.invoice_type === 3
                    ? "225px"
                    : "",
              }}
            >
              <span
                style={
                  ledgerData?.invoice_type
                    ? styleColor(ledgerData?.invoice_type)
                    : blank()
                }
              >
                {ledgerData?.invoice_type === 1
                  ? "Expense"
                  : ledgerData?.invoice_type === 2
                  ? "Sales"
                  : "Other Entries"}{" "}
                {ledgerData?.category}
              </span>
            </td>
            {ledgerData?.invoice_type === 1 &&
              (isEditExpensePresent && ledgerData?.invoice_type === 1 ? (
                renderEditIcon(finalLink)
              ) : (
                <td></td>
              ))}
            {ledgerData?.invoice_type === 2 &&
              (isEditSalesPresent && ledgerData?.invoice_type === 2 ? (
                renderEditIcon(finalLink)
              ) : (
                <td></td>
              ))}
            {ledgerData?.invoice_type === 3 &&
              (isEditOthersPresent && ledgerData?.invoice_type === 3 ? (
                renderEditIcon(finalLink)
              ) : (
                <td></td>
              ))}
          </tr>
        );
      });

    return finalData;
  };

  return <>{renderLedgerStatementData()}</>;
};

export default LedgerStatementTableData;
